import styled from 'styled-components';
import { Container } from 'react-bootstrap';

export default styled(Container)`
  @media (min-width: 1200px){
    min-width: 1280px;
  }
`